import { render, staticRenderFns } from "./FeedbackContentDetailModal.vue?vue&type=template&id=bb0de4b4&scoped=true&"
import script from "./FeedbackContentDetailModal.vue?vue&type=script&lang=js&"
export * from "./FeedbackContentDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackContentDetailModal.vue?vue&type=style&index=0&id=bb0de4b4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0de4b4",
  null
  
)

export default component.exports